import { ReceiptsViewService } from './ReceiptsViewService';
import { data } from './mockData';
import { SupplierItem } from './types';

export const ReceiptsViewServiceImpl: ReceiptsViewService = {
  getReceiptsData: async (): Promise<SupplierItem[]> => {
    return Promise.resolve(data);
  },
};
